import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleItem } from '../../api/models';
import { enumUserRole } from '../utils/enum-user-role';

@Pipe({ name: 'showRole' })
export class DisplayRolePipe implements PipeTransform {
  transform(role: UserRoleItem, ...args: boolean[]): string {
    switch (role.id) {
      case enumUserRole.ADMINISTRATOR:
        return args && args[0] === true
          ? `<div class="badge-container-role muted-g-bg">Administrator</div>`
          : 'Administrator';
      case enumUserRole.UTENTE:
        return args && args[0] === true
          ? `<div class="badge-container-role muted-t-bg">Traveler</div>`
          : 'Traveler';
      case enumUserRole.TOURLEADER:
        return args && args[0] === true
          ? `<div class="badge-container-role muted-o-bg">Tour Leader</div>`
          : 'Tour Leader';
      case enumUserRole.TOURLEADER_PRO:
        return args && args[0] === true
          ? `<div class="badge-container-role muted-s-bg">Tour Leader Pro</div>`
          : 'Tour Leader Pro';
    }
    throw new Error("La showRolePipe non riconosce il ruolo")
  }
}
